import React from 'react';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';
import ReadOnlyData from '../ReadOnlyData';
import EditableData from '../EditableData';
import Typography from '@mui/material/Typography';

import SelectInput from '@geomatico/geocomponents/SelectInput';

import {FIRE_RISK, MACHINERY_DIFFICULTY, SPECIES_INCLUDED_BIOMASCO2} from '../../../../../config';

import grey from '@mui/material/colors/grey';
import { lighten } from '@mui/material/styles';

const placeHolder = {

  '& .SelectInput-placeholder': {
    fontStyle: 'italic',
    color: grey[700]
  }};

const PlanningMassDescription = ({
  intervention_zone_id,
  species_id, 
  age, 
  area, 
  number_per_ha, 
  dominant_height, 
  basimetric_area, 
  site_index, 
  fire_risk,
  machinery_difficulty, 
  onMassChange,
  onInterventionZoneUpdate
}) => {

  const {t} = useTranslation();

  const speciesOptions = SPECIES_INCLUDED_BIOMASCO2.map(s => (
    {
      id: s.xorforId.toString(),
      label: s.name.toUpperCase()
    }
  ));

  return <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start', mt: 1}}>
    <Box sx={{display: 'flex', flexDirection: 'row', alignItems: 'flex-start', gap: 4}}>
      <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 0.5}}>
        <ReadOnlyData label='ID Rodal' value={intervention_zone_id}/>
        <ReadOnlyData label='Área' value={area} />
        <Box sx={{display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 3.5}}>
          <Typography sx={{fontWeight: 900}}>{t('Especie')}</Typography>
          <SelectInput
            options={speciesOptions}
            selectedOptionId={species_id}
            onOptionChange={(value) => onMassChange({species_id: value})}
            sx={{'& .SelectInput-select': {width: '225px'}}}
          />
        </Box>
      </Box>
      <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 0.5}}>
        <EditableData onChange={(value) => onMassChange({number_per_ha: value})} label='Nºpies/ha' value={number_per_ha} min={0} isRequired={true}/>
        <EditableData onChange={(value) => onMassChange({dominant_height: value})} label='Ho(m)' value={dominant_height} min={0} isRequired={true}/>
        <EditableData onChange={(value) => onMassChange({basimetric_area: value})} label='G' value={basimetric_area} min={1} isRequired={true}/>
      </Box>
      <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 0.5}}>
        <EditableData onChange={(value) => onMassChange({initial_age: value})} label='Edad' value={age} min={0}/>
        <EditableData onChange={(value) => onMassChange({site_index: value === 0 ? undefined : value})} label='IS' value={site_index} min={0}/>
      </Box>
      <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 0.5}}>
        <Box sx={{display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 3.5}}>
          <Typography sx={{fontWeight: 900, width: '160px'}}>{t('Zona riesgo incendio')}<span style={{color: 'red'}}>*</span></Typography>
          <SelectInput
            options={FIRE_RISK}
            allowEmptyValue={true}
            placeholderLabel={t('Seleccionar')}
            selectedOptionId={fire_risk || ''}
            onOptionChange={(value) => onInterventionZoneUpdate({fire_risk: value || null})}
            sx={{
              '& .SelectInput-select': {
                width: '120px',
                backgroundColor: !fire_risk ? lighten('#ff0000', 0.85) : 'transparent'
              }
            }}
            menuSx={placeHolder}
          />
        </Box>
        <Box sx={{display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 3.5}}>
          <Typography sx={{fontWeight: 900, width: '160px'}}>{t('Dificultad mecanizado')}<span style={{color: 'red'}}>*</span></Typography>
          <SelectInput
            options={MACHINERY_DIFFICULTY}
            allowEmptyValue={true}
            placeholderLabel={t('Seleccionar')}
            selectedOptionId={machinery_difficulty || ''}
            onOptionChange={(value) => onInterventionZoneUpdate({machinery_difficulty: value || null})}
            sx={{
              '& .SelectInput-select': {
                border: 'red',
                width: '120px',
                backgroundColor: !machinery_difficulty ? lighten('#ff0000', 0.85) : 'white'
              }
            }}
            menuSx={placeHolder}
          />
        </Box>
      </Box>
    </Box>
  </Box>;
};

PlanningMassDescription.propTypes = {
  intervention_zone_id: PropTypes.number.isRequired,
  species_id: PropTypes.string.isRequired,
  age: PropTypes.number,
  area: PropTypes.number.isRequired,
  number_per_ha: PropTypes.number,
  dominant_height: PropTypes.number,
  basimetric_area: PropTypes.number,
  site_index: PropTypes.number,
  fire_risk: PropTypes.string,
  machinery_difficulty: PropTypes.string,
  onMassChange: PropTypes.func.isRequired,
  onInterventionZoneUpdate: PropTypes.func.isRequired
};

export default PlanningMassDescription;